import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import type { SiteMethod } from '@/lib/form-site';
import classes from './FormCreate.module.css';

export const SITE_METHODS: SiteMethod[] = ['own', 'hosted', 'link'];

export interface MethodChoiceProps {
  value: SiteMethod;
  onChange: (next: SiteMethod) => void;
  /** Radio group name, unique per page. */
  name: string;
  /** The shorter copy of the guided start on Home. */
  compact?: boolean;
}

/** The three answers to "where does the form go", as radio cards. */
export function MethodChoice({ value, onChange, name, compact }: MethodChoiceProps) {
  const { t } = useTranslation();
  const copy = compact ? 'create.quickMethod' : 'create.method';
  const id = useId();

  return (
    <div className={compact ? classes.optionsRow : classes.options}>
      {SITE_METHODS.map((method) => (
        <label
          key={method}
          className={`${classes.option}${value === method ? ` ${classes.optionOn}` : ''}`}
        >
          <input
            type="radio"
            name={name}
            value={method}
            checked={value === method}
            onChange={() => onChange(method)}
            aria-labelledby={`${id}-${method}`}
            aria-describedby={`${id}-${method}-body`}
          />
          <span className={classes.optionText}>
            <strong id={`${id}-${method}`}>{t(`${copy}.${method}.title`)}</strong>
            <span id={`${id}-${method}-body`} className={classes.sub}>
              {t(`${copy}.${method}.body`)}
            </span>
          </span>
        </label>
      ))}
    </div>
  );
}
